import { CourseProgressFilter } from '@/components/_deprecated/courses/progress/CourseProgressFilter';
import { ListCourseProgressFilters } from '@/data/services/courseProgressServices';
import { CourseFormatEnum } from '@/models/Course';
import StudentDashboardStats from '@/models/StudentDashboard';

export type CourseProgressStatus = 'completed' | 'in_progress';

export interface SeparatedCourses {
  completed: StudentDashboardStats[];
  inProgress: StudentDashboardStats[];
}

export function separateCoursesByProgress(
  courses: StudentDashboardStats[],
): SeparatedCourses {
  const completed: StudentDashboardStats[] = [];
  const inProgress: StudentDashboardStats[] = [];

  for (const course of courses) {
    if (course.progress >= 1) {
      completed.push(course);
    } else {
      inProgress.push(course);
    }
  }

  return { completed, inProgress };
}

export function isCourseCompleted(course: StudentDashboardStats): boolean {
  return course.progress >= 1;
}

export function isCourseInProgress(course: StudentDashboardStats): boolean {
  return course.progress < 1;
}

export function getCourseProgressStatus(
  course: StudentDashboardStats,
): CourseProgressStatus {
  return isCourseCompleted(course) ? 'completed' : 'in_progress';
}

export function filterCoursesByStatus(
  courses: StudentDashboardStats[],
  status: CourseProgressStatus,
): StudentDashboardStats[] {
  return courses.filter(course => getCourseProgressStatus(course) === status);
}

export function countCoursesByProgress(courses: StudentDashboardStats[]): {
  completed: number;
  inProgress: number;
  total: number;
} {
  const { completed, inProgress } = separateCoursesByProgress(courses);

  return {
    completed: completed.length,
    inProgress: inProgress.length,
    total: courses.length,
  };
}

export const filterToServiceFilterAdapter = (
  filter: CourseProgressFilter,
): ListCourseProgressFilters => {
  const filterCourseFormats: ListCourseProgressFilters = {};
  if (filter.courseFormats) {
    filterCourseFormats.courseFormats = [
      filter.courseFormats as CourseFormatEnum,
    ];
  }
  if (filter.courseFormats === 'ASYNC') {
    filterCourseFormats.courseFormats = [CourseFormatEnum.SELF_PACED];
  }

  if (filter.courseFormats === 'ALL') {
    filterCourseFormats.courseFormats = undefined;
  }

  return {
    ...filterCourseFormats,
    search: filter.search,
    ordering: filter.ordering,
  };
};
